import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Toolbar } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    quizTitle: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    }
})

//TODO image handler for client image and icons
class ClientHeader extends Component {
    constructor(props){
        super(props);
    }
//http://dev20.pdx1iis11.wellsource.com/WsWebServicePlatform/handlers/WsGetImage.ashx?img=2B37CB53-99AF-41F0-9A15-0E17BEA74B38
    render() {
        const {classes} = this.props
        return (
            <AppBar position="static" style={{backgroundColor:'white'}} >
                <Toolbar>
                        <div style={{flex:1}}>
                        <img  style={{maxWidth: '95%', maxHeight: '100px'}} src={'../' + this.props.clientheader.ClientLogoSource + '/'} alt={this.props.clientheader.ClientLogoAltText} id="logo-image"></img> 
                        </div>
                        <h3 className={classes.quizTitle}></h3>
                </Toolbar>
                
            </AppBar>
        )
    }
}

//<img src='../public/welltok.jpeg' height="80px"></img>

export default withStyles(styles)(ClientHeader);
/*
const ClientHeader = ({ clientheader }) => {
	console.log("clientHeader: ", clientheader)
    return (
        <AppBar position="static">
            <Toolbar>
                <h1>{clientheader.Name}</h1>
                <b> Hi, Alex</b>
            </Toolbar>
            
        </AppBar>
    )
}

*/

